import { useAppDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { restreamingToggled } from 'features/restreamer/actions';
import { RestreamingConnectedBadgeColor } from 'features/restreamer/constants';
import { useTheme } from '@mui/material/styles';
import { useRestreamer } from 'features/restreamer/useRestreamer';

export const useRestreamingControl = () => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const { isFeatureAvailable, active, status } = useRestreamer();

  const theme = useTheme();

  const toggleRestreaming = () => {
    dispatch(restreamingToggled());
  };

  const renderLabel = () => {
    if (status === 'starting') {
      return t('toolbar.restreaming.starting');
    }

    if (active) {
      return t('toolbar.restreaming.stop');
    }

    return t('toolbar.restreaming.start');
  };

  const renderBadgeColor = () => {
    if (status === 'starting') {
      return theme.palette.grey['600'];
    }

    return RestreamingConnectedBadgeColor as any;
  };

  return {
    toggleRestreaming,
    status,
    active,
    icon: 'streaming',
    label: renderLabel(),
    isFeatureAvailable,
    badgeColor: renderBadgeColor(),
  };
};
